import { isEqual, omitBy } from 'lodash'

import { DateFields } from '@sigma-frontend-libs/commons'
import { EVENTSHISTORY_TYPES } from '@sigma-legacy-libs/essentials/lib/constants'
import { OrderDirections } from '@sigmasms/shared-types'

import { isEmpty } from '@/utils'

export const $order = [ [ DateFields.createdAt, OrderDirections.DESC ] ]

export function calcChanges(item, nextItem) {
  switch (item.type) {
    case EVENTSHISTORY_TYPES.created:
    case EVENTSHISTORY_TYPES.imported: {
      const newValues = {}
      for (const key in item.data) {
        if (!isEmpty(item.data[key])) {
          newValues[key] = item.data[key]
        }
      }

      return { newValues }
    }
    default: {
      const newValues = omitBy(item.data, (value, key) => {
        return isEqual(nextItem.data[key], value)
      })
      const oldValues = Object.keys(newValues).reduce((result, key) => {
        result[key] = nextItem.data[key]

        return result
      }, {})

      return {
        newValues,
        oldValues
      }
    }
  }
}
